module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./StoreHomeView.js"));
	}, "StoreHomeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=StoreHomeView!./src/pages/Store/StoreHome/StoreHomeView.js
// module id = 1178
// module chunks = 438